import { ScreenConfig } from "@cc/pixi-app";
import { ScreenSplash } from "./screens/ScreenSplash";
import { ScreenGame } from './screens/ScreenGame';
import { ScreenPackSelect } from './screens/ScreenPackSelect';
import { ScreenMissionSelect } from './screens/ScreenMissionSelect';
import { ScreenAvatarCreator } from './screens/ScreenAvatarCreator';
import { ScreenPhotoGallery } from './screens/ScreenPhotoGallery';

/**
 * @type {[ScreenConfig]}
 */
export const screenConfig = [
    {
        name: "splash",
        class: ScreenSplash,
        assetTags: ["common", "config", "splash", "ui", "particles", "logo"],
        navigation: {},
        screenState: {}
    },
    {
        name: "packs",
        class: ScreenPackSelect,
        assetTags: ["common", "pack-select", "ui", "particles", "avatar", "logo"],
        navigation: {},
        screenState: {}
    },
    {
        name: "avatarCreator",
        class: ScreenAvatarCreator,
        assetTags: ["common", "ui", "particles", "avatar", "logo"],
        navigation: {},
        screenState: {}
    },
    {
        name: "missionSelect",
        class: ScreenMissionSelect,
        assetTags: ["common", "ui", "particles", "avatar", "photo-gallery", "logo"],
        navigation: {},
        screenState: {}
    },
    {
        name: "game",
        class: ScreenGame,
        assetTags: ["common", "game", "ui", "avatar", "tutorial", "logo"],
        navigation: {},
        screenState: {}
    },
    {
        name: "photoGallery",
        class: ScreenPhotoGallery,
        assetTags: ["common", "game", "ui", "avatar", "photo-gallery", "logo"],
        navigation: {},
        screenState: {}
    }
];
